var _g, _path;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgSafeicon(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Component_37_1",
    "data-name": "Component 37 \\u2013 1",
    xmlns: "http://www.w3.org/2000/svg",
    width: 61.946,
    height: 56.118,
    viewBox: "0 0 61.946 56.118",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Component_35_1",
    "data-name": "Component 35 \\u2013 1"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_1015",
    "data-name": "Path 1015",
    d: "M427.5,391.408h-1c-3.578,0-7.157.021-10.733-.018a7.834,7.834,0,0,1-2.428-.365,7.744,7.744,0,0,1-5.139-8.443,7.578,7.578,0,0,1,7.689-6.656c3.523-.01,7.046,0,10.569,0H427.5c0-1.811,0-3.512,0-5.213a8.879,8.879,0,0,0-5.207-8.407.941.941,0,0,1-.6-1c.026-1.789.012-3.579.009-5.368a7.7,7.7,0,0,0-8.038-8.058q-7.968-.01-15.937,0c-7.79,0-15.579-.013-23.368.006a8.745,8.745,0,0,0-8.792,8.82q0,19.074.009,38.149a8.429,8.429,0,0,0,.238,2.119,8.792,8.792,0,0,0,7.2,6.854,8.694,8.694,0,0,0,1.72.158q21.8.014,43.6,0a9.056,9.056,0,0,0,8.557-5.756C427.78,396.047,427.411,393.781,427.5,391.408Zm-52.926-29.989a4.849,4.849,0,0,1-.635-9.677c.3-.016.606-.01.909-.01,12.848,0,25.7.037,38.546-.032a4.122,4.122,0,0,1,4.44,4.439c-.1,1.72-.019,3.452-.019,5.285h-.9Q395.748,361.423,374.575,361.419Z",
    transform: "translate(-365.558 -347.868)",
    fill: "#d4dc60"
  }))), _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "Path_1016",
    "data-name": "Path 1016",
    d: "M404.077,372.7a3.889,3.889,0,0,0-2.6,4.281,3.731,3.731,0,0,0,3.722,3.3c3.687.012,7.372.005,11.058,0,.21,0,.419-.039.647-.062v-7.629a3.9,3.9,0,0,0-.391-.047q-5.776,0-11.554.005A2.963,2.963,0,0,0,404.077,372.7Zm3.166,3.74a1.924,1.924,0,0,1-1.973,1.9,1.925,1.925,0,0,1,.057-3.85A1.917,1.917,0,0,1,407.243,376.439Z",
    transform: "translate(-354.995 -340.604)",
    fill: "#d4dc60"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgSafeicon);
export default __webpack_public_path__ + "lbHeaderFiles/static/media/safe.icon.1b99924762a6f9b4715ada91bbf15dea.svg";
export { ForwardRef as ReactComponent };